<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card class="elevation-12">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>CP Login</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form"
                    @submit.prevent="login"
                    v-model="formValid">
              <v-text-field
                v-if="!hidePartner"
                label="Partner Email"
                name="email"
                prepend-icon="mdi-email"
                type="text"
                v-model="email"
                :error="error.email"
                :error-messages="errorMessage.email"
                :rules="[rules.required]"
              ></v-text-field>
              <v-radio-group v-model="loginMethod"
                             row>
                <v-radio
                  label="Use Email"
                  value="email"
                ></v-radio>
                <v-radio
                  label="Use Username"
                  value="username"
                ></v-radio>
              </v-radio-group>
              <v-text-field v-if="loginMethod === 'email'"
                            label="Email"
                            name="email2"
                            prepend-icon="mdi-email"
                            type="text"
                            v-model="email2"
                            :error="error.email2"
                            :error-messages="errorMessage.email2"
                            :rules="[rules.required]"
              >
              </v-text-field>
              <v-text-field v-if="loginMethod === 'username'"
                            label="Username"
                            name="username"
                            prepend-icon="mdi-account"
                            type="text"
                            v-model="username"
                            :error="error.username"
                            :error-messages="errorMessage.username"
                            :rules="[rules.required]"
              >
              </v-text-field>
              <v-text-field v-if="loginMethod === 'username'"
                            label="Password"
                            name="password"
                            prepend-icon="mdi-password"
                            type="password"
                            v-model="password"
                            :error="error.password"
                            :error-messages="errorMessage.password"
                            :rules="[rules.required]"
              >
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="sso-btn"
              color="primary"
              outlined
              :loading="processing"
              :disabled="processing"
              @click="login()"
            ><b>Login</b></v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'CpLoginVerz',
  data() {
    return {
      formValid: false,
      processing: false,
      valid: false,
      email: 'henry@verzdesign.com',
      email2: '',
      username: '',
      password: '',
      loginMethod: 'email',
      error: {
        email: false,
        email2: false,
        username: false,
        password: false,
      },
      errorMessage: {
        email: '',
        email2: '',
        username: '',
        password: '',
      },
      rules: {
        required: (value) => !!value || 'This field is required.',
      },
      hidePartner: true,
    };
  },
  async mounted() {
    if (this.$route.query.token) {
      await this.$api.post('cp/login', {
        login_method: 'token',
        token: this.$route.query.token,
      }).then((response) => {
        this.$store.dispatch('setCurrentUser', response.data);
        this.$store.dispatch('showDashboard');
        localStorage.setItem('app', JSON.stringify(this.$store.state));
        this.$router.push({
          name: 'CpLoginCpanel',
        });
      })
        .catch((error) => {
          if (error.response) {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'error',
              message: error.response.data.message,
            });
          } else {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'error',
              message: error.message,
            });
          }
          this.$store.dispatch('reset');
        });
    }

    if (this.$route.query.email) {
      this.email = this.$route.query.email;
    }

    if (this.$route.query.sso) {
      if (this.$route.query.sso === 'google') {
        this.verifySignInGoogle();
      }
    }
  },
  methods: {
    login() {
      if (this.$refs.form.validate()) {
        this.processing = true;
        this.$api.post('cp/login', {
          email: this.email,
          email2: this.email2,
          login_method: this.loginMethod,
          username: this.username,
          password: this.password,
        }).then((response) => {
          if (this.loginMethod === 'email') {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'success',
              message: 'A single sign on link has been sent to your email.',
            });
          } else {
            this.$store.dispatch('setCurrentUser', response.data);
            this.$store.dispatch('showDashboard');
            localStorage.setItem('app', JSON.stringify(this.$store.state));
            this.$router.push({
              name: 'CpLoginCpanel',
            });
          }
        })
          .catch((error) => {
            if (error.response) {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: error.response.data.message,
              });
            } else {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: error.message,
              });
            }
          })
          .finally(() => {
            this.processing = false;
          });
      }
    },
    signInGoogle() {
      this.$api.post('cp/sso/auth-url', {
        type: 'google',
        email: this.email,
      }).then((response) => {
        if (response.data) {
          window.location.href = response.data;
        }
      });
    },
    verifySignInGoogle() {
      this.$api.post('cp/sso/login', {
        type: 'google',
        brand: 'cpgce',
        code: this.$route.query.code,
        email: this.$route.query.email,
      }).then((response) => {
        this.$store.dispatch('setCurrentUser', response.data);
        this.$store.dispatch('showDashboard');
        localStorage.setItem('app', JSON.stringify(this.$store.state));
        this.$router.push({
          name: 'CpLoginCpanel',
        });
      })
        .catch((error) => {
          if (error.response) {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'error',
              message: error.response.data.message,
            });
          } else {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'error',
              message: error.message,
            });
          }
        })
        .finally(() => {
          this.processing = false;
        });
    },
  },
};
</script>

<style scoped>
  .sso-btn {
    min-width: 224px !important;
  }
</style>
